<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>

        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="IAReport">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-9">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/img/purse.png"
                                                        class="mh-45px pb-2">
                                                    <div class="ml-2">
                                                        <h3 class="main-content-label mb-1"><b>
                                                                IA Marks Count Report
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            List IA Marks Count Report
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row clearfix mt-2">
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Session</mat-label>
                                                            <mat-select #select232 placeholder="Session"
                                                                class="colorblack" formControlName="SessionId">
                                                                <mat-select-filter *ngIf="select232.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                    [array]="sessionList"
                                                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of SessionFilterList"
                                                                    [value]="item.SnNo" (click)="fetchCollege()">
                                                                    {{item.SnName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> College Name</mat-label>
                                                    <mat-select #select23 placeholder="CgCode" class="colorblack"
                                                        formControlName="college">
                                                        <mat-select-filter *ngIf="select23.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                            [array]="collegeList"
                                                            (filteredReturn)="filteredCollegeList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCollegeList"
                                                            (click)="fetchCourse(item.CgCode)" [value]="item.CgCode">
                                                            {{item.CgCode}} - {{item.CgName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-2">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> Course Name</mat-label>
                                                    <mat-select #select29 placeholder="CoCode" class="colorblack"
                                                        formControlName="course">
                                                        <mat-select-filter *ngIf="select29.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                            [array]="CourseList"
                                                            (filteredReturn)="filteredCourseList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCourseList"
                                                            [value]="item.CoCgCoCode"
                                                            (click)="fetchExam(item.CoCgCoCode)">
                                                            {{item.CoCgCoCode}} - {{item.CoName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Exam</mat-label>
                                                            <mat-select formControlName="Exam" #select3901
                                                                placeholder="Exam Available" class="colorblack">
                                                                <mat-select-filter *ngIf="select3901.focused"
                                                                    [placeholder]="'Exam Available'"
                                                                    [displayMember]="'EmName'" [array]="ExamAList"
                                                                    (filteredReturn)="filteredExamAList =$event">
                                                                </mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredExamAList"
                                                                    [value]="item.EmId" (click)="getSubject(item)">
                                                                    {{item.EmCode}} - {{item.EmName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2" *ngIf="isBranch">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Branch
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="Branch"
                                                            formControlName="Branch">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="BranchList"
                                                                (filteredReturn)="filteredListBranch =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListBranch"
                                                                [value]="item.StrId" (click)="getStr(item)">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Subject
                                                        </mat-label>
                                                        <mat-select #select2345 placeholder="subject"
                                                            formControlName="EsParentId">
                                                            <mat-select-filter *ngIf="select2345.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                                [array]="subjectList"
                                                                (filteredReturn)="filteredsubjectList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredsubjectList"
                                                                [value]="item.EsId" (click)="getCount()">
                                                                {{item.EsCode}}-{{item.EsName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <hr>
                                            <div *ngIf="Table"  class="table-responsive table-container">
                                                <table appShortTable id="datatable"
                                                    class="table table-bordered text-nowrap text-left">
                                                    <thead>
                                                        <tr>
                                                            <th class="f600 ">
                                                                Sr. No
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Subject Name
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Head
                                                            </th>
                                                            <th  class="f600 text-center">
                                                                Total Student
                                                            </th>
                                                            <th  class="f600 text-center">
                                                                Submitted Student Count
                                                            </th>
                                                            <th  class="f600 text-center">
                                                                Pending Student Count
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data">
                                                        <tr *ngFor="let summary of summaryData, let i = index">
                                                            <td class=" text-center"> {{i + 1}} </td>
                                                            <td > {{summary.SubjectName}} </td>
                                                            <td >{{summary.SubjectHead}} </td>
                                                            <td class=" text-center">{{summary.Total}} </td>
                                                            <td class=" text-center">{{summary.Submitted}} </td>
                                                            <td class=" text-center">{{summary.Pending}} </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>